var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params)?_c('WZNukeOverlay',{attrs:{"overlay":_vm.params,"duration":"10000"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }